/* PupStyle A11y-Enhancements (FIX-11) — additiv, kein Verhalten geändert.
   Vergibt zugängliche Namen an JS-generierte Slider-Dots, die sonst keinen Screenreader-Namen haben.
   Konfigurator (cp-*) wird bewusst NICHT angefasst. */
(function () {
  function labelDots(root) {
    try {
      var dots = (root || document).querySelectorAll('.hdt-slider__dot:not([aria-label]):not([data-cp])');
      dots.forEach(function (d, i) {
        if (d.closest('[class*="cp-"]')) return; // Konfigurator nie anfassen
        if (!d.getAttribute('aria-label') && !d.textContent.trim()) {
          d.setAttribute('aria-label', 'Folie ' + (i + 1));
        }
        if (!d.getAttribute('role')) d.setAttribute('role', 'button');
      });
    } catch (e) { /* still & sicher */ }
  }
  function run() { labelDots(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ run(); setTimeout(run, 1200); });
  } else { run(); setTimeout(run, 1200); }
})();
